const links = {
  customerServices: [
    { label: 'FAQs', path: '#' },
    { label: 'Track Order', path: '#' },
    { label: 'Returns', path: '#' },
    { label: 'Delivery', path: '#' },
    { label: 'Payment', path: '#' },
  ],
  about: [
    { label: 'About us', path: '#' },
    { label: 'Blog', path: '#' },
    { label: 'Privacy Policy', path: '#' },
    { label: 'Terms & Conditions', path: '#' },
  ],
  connect: [
    { label: 'Facebook', path: 'https://facebook.com' },
    { label: 'Instagram', path: 'https://instagram.com' },
    { label: 'LinekdIn', path: 'https://linkedin.com' },
  ],
};

export default links;
